var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1500(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 81,
    viewBox: "0 0 203 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1527_646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 24,
    width: 34,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M199.586 36.6898V46.2481H166.578V36.6898H199.586ZM188.341 24.1217V59.18H177.922V24.1217H188.341Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1527_646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1757"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1661",
    x: 141.402,
    y: -2.62109,
    width: 43.3471,
    height: 43.3471,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1663",
    x: 141.402,
    y: 40.7246,
    width: 43.3471,
    height: 43.3471,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1662",
    x: 184.746,
    y: -2.62109,
    width: 43.3471,
    height: 43.3471,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1664",
    x: 184.746,
    y: 40.7246,
    width: 43.3471,
    height: 43.3471,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1736"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    cx: 166.599,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 169.626,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    cx: 172.653,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 175.673,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51",
    cx: 178.7,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 181.724,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53",
    cx: 184.747,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54",
    cx: 187.77,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 190.798,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 193.817,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 196.845,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 199.872,
    cy: 25.9062,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1737"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_2",
    cx: 166.599,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_2",
    cx: 169.626,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_2",
    cx: 172.653,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_2",
    cx: 175.673,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_2",
    cx: 178.7,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_2",
    cx: 181.724,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_2",
    cx: 184.747,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_2",
    cx: 187.77,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_2",
    cx: 190.798,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_2",
    cx: 193.817,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_2",
    cx: 196.845,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_2",
    cx: 199.872,
    cy: 28.9325,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1738"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_3",
    cx: 166.599,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_3",
    cx: 169.626,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_3",
    cx: 172.653,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_3",
    cx: 175.673,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_3",
    cx: 178.7,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_3",
    cx: 181.724,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_3",
    cx: 184.747,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_3",
    cx: 187.77,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_3",
    cx: 190.798,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_3",
    cx: 193.817,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_3",
    cx: 196.845,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_3",
    cx: 199.872,
    cy: 31.954,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1739"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_4",
    cx: 166.599,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_4",
    cx: 169.626,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_4",
    cx: 172.653,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_4",
    cx: 175.673,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_4",
    cx: 178.7,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_4",
    cx: 181.724,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_4",
    cx: 184.747,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_4",
    cx: 187.77,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_4",
    cx: 190.798,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_4",
    cx: 193.817,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_4",
    cx: 196.845,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_4",
    cx: 199.872,
    cy: 34.9784,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1740"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_5",
    cx: 166.599,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_5",
    cx: 169.626,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_5",
    cx: 172.653,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_5",
    cx: 175.673,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_5",
    cx: 178.7,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_5",
    cx: 181.724,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_5",
    cx: 184.747,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_5",
    cx: 187.77,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_5",
    cx: 190.798,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_5",
    cx: 193.817,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_5",
    cx: 196.845,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_5",
    cx: 199.872,
    cy: 38.0028,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1741"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_6",
    cx: 166.599,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_6",
    cx: 169.626,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_6",
    cx: 172.653,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_6",
    cx: 175.673,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_6",
    cx: 178.7,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_6",
    cx: 181.724,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_6",
    cx: 184.747,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_6",
    cx: 187.77,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_6",
    cx: 190.798,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_6",
    cx: 193.817,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_6",
    cx: 196.845,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_6",
    cx: 199.872,
    cy: 41.0263,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1742"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_7",
    cx: 166.599,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_7",
    cx: 169.626,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_7",
    cx: 172.653,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_7",
    cx: 175.673,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_7",
    cx: 178.7,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_7",
    cx: 181.724,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_7",
    cx: 184.747,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_7",
    cx: 187.77,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_7",
    cx: 190.798,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_7",
    cx: 193.817,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_7",
    cx: 196.845,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_7",
    cx: 199.872,
    cy: 44.0507,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1743"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_8",
    cx: 166.599,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_8",
    cx: 169.626,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_8",
    cx: 172.653,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_8",
    cx: 175.673,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_8",
    cx: 178.7,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_8",
    cx: 181.724,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_8",
    cx: 184.747,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_8",
    cx: 187.77,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_8",
    cx: 190.798,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_8",
    cx: 193.817,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_8",
    cx: 196.845,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_8",
    cx: 199.872,
    cy: 47.0751,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1744"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_9",
    cx: 166.599,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_9",
    cx: 169.626,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_9",
    cx: 172.653,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_9",
    cx: 175.673,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_9",
    cx: 178.7,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_9",
    cx: 181.724,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_9",
    cx: 184.747,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_9",
    cx: 187.77,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_9",
    cx: 190.798,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_9",
    cx: 193.817,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_9",
    cx: 196.845,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_9",
    cx: 199.872,
    cy: 50.0985,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1745"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_10",
    cx: 166.599,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_10",
    cx: 169.626,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_10",
    cx: 172.653,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_10",
    cx: 175.673,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_10",
    cx: 178.7,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_10",
    cx: 181.724,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_10",
    cx: 184.747,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_10",
    cx: 187.77,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_10",
    cx: 190.798,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_10",
    cx: 193.817,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_10",
    cx: 196.845,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_10",
    cx: 199.872,
    cy: 53.1249,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1746"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_11",
    cx: 166.599,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_11",
    cx: 169.626,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_11",
    cx: 172.653,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_11",
    cx: 175.673,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_11",
    cx: 178.7,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_11",
    cx: 181.724,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_11",
    cx: 184.747,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_11",
    cx: 187.77,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_11",
    cx: 190.798,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_11",
    cx: 193.817,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_11",
    cx: 196.845,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_11",
    cx: 199.872,
    cy: 56.1493,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1747"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47_12",
    cx: 166.599,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_12",
    cx: 169.626,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_12",
    cx: 172.653,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_12",
    cx: 175.673,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_12",
    cx: 178.7,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_12",
    cx: 181.724,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_12",
    cx: 184.747,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_12",
    cx: 187.77,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_12",
    cx: 190.798,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_12",
    cx: 193.817,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_12",
    cx: 196.845,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_12",
    cx: 199.872,
    cy: 59.1737,
    r: 0.403229,
    fill: "#D9D9D9"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "+_2",
    d: "M198.476 35.681H199.081V35.0762H198.476V35.681ZM198.476 45.2393V45.8442H199.081V45.2393H198.476ZM165.469 45.2393H164.864V45.8442H165.469V45.2393ZM165.469 35.681V35.0762H164.864V35.681H165.469ZM187.231 23.1129H187.836V22.5081H187.231V23.1129ZM187.231 58.1712V58.7761H187.836V58.1712H187.231ZM176.813 58.1712H176.208V58.7761H176.813V58.1712ZM176.813 23.1129V22.5081H176.208V23.1129H176.813ZM197.872 35.681V45.2393H199.081V35.681H197.872ZM198.476 44.6345H165.469V45.8442H198.476V44.6345ZM166.074 45.2393V35.681H164.864V45.2393H166.074ZM165.469 36.2858H198.476V35.0762H165.469V36.2858ZM186.627 23.1129V58.1712H187.836V23.1129H186.627ZM187.231 57.5664H176.813V58.7761H187.231V57.5664ZM177.418 58.1712V23.1129H176.208V58.1712H177.418ZM176.813 23.7178H187.231V22.5081H176.813V23.7178Z",
    fill: "#202124"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1527_646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 23,
    height: 49
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M28.7591 16.5876V64.7432H17.6132V29.1557L6.63271 32.3639V23.897L27.7338 16.5876H28.7591Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1527_646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1757_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1661_2",
    x: -21.1133,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1663_2",
    x: -21.1133,
    y: 41.1387,
    width: 43.3471,
    height: 43.3471,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1662_2",
    x: 22.2344,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1664_2",
    x: 22.2344,
    y: 41.1387,
    width: 43.3471,
    height: 43.3471,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1756_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1733"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_13",
    cx: 7.11026,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_13",
    cx: 10.1376,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_13",
    cx: 13.1571,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_13",
    cx: 16.1845,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_13",
    cx: 19.2079,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_13",
    cx: 22.2314,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_13",
    cx: 25.2548,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_13",
    cx: 28.2821,
    cy: 17.248,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1734"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_14",
    cx: 7.11026,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_14",
    cx: 10.1376,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_14",
    cx: 13.1571,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_14",
    cx: 16.1845,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_14",
    cx: 19.2079,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_14",
    cx: 22.2314,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_14",
    cx: 25.2548,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_14",
    cx: 28.2821,
    cy: 20.2714,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1735"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_15",
    cx: 7.11026,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_15",
    cx: 10.1376,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_15",
    cx: 13.1571,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_15",
    cx: 16.1845,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_15",
    cx: 19.2079,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_15",
    cx: 22.2314,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_15",
    cx: 25.2548,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_15",
    cx: 28.2821,
    cy: 23.2958,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1736_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_16",
    cx: 7.11026,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_16",
    cx: 10.1376,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_16",
    cx: 13.1571,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_16",
    cx: 16.1845,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_16",
    cx: 19.2079,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_16",
    cx: 22.2314,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_16",
    cx: 25.2548,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_16",
    cx: 28.2821,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1737_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_17",
    cx: 7.11026,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_17",
    cx: 10.1376,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_17",
    cx: 13.1571,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_17",
    cx: 16.1845,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_17",
    cx: 19.2079,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_17",
    cx: 22.2314,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_17",
    cx: 25.2548,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_17",
    cx: 28.2821,
    cy: 29.3466,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1738_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_18",
    cx: 7.11026,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_18",
    cx: 10.1376,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_18",
    cx: 13.1571,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_18",
    cx: 16.1845,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_18",
    cx: 19.2079,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_18",
    cx: 22.2314,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_18",
    cx: 25.2548,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_18",
    cx: 28.2821,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1739_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_19",
    cx: 7.11026,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_19",
    cx: 10.1376,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_19",
    cx: 13.1571,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_19",
    cx: 16.1845,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_19",
    cx: 19.2079,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_19",
    cx: 22.2314,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_19",
    cx: 25.2548,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_19",
    cx: 28.2821,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1740_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_20",
    cx: 7.11026,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_20",
    cx: 10.1376,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_20",
    cx: 13.1571,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_20",
    cx: 16.1845,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_20",
    cx: 19.2079,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_20",
    cx: 22.2314,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_20",
    cx: 25.2548,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_20",
    cx: 28.2821,
    cy: 38.4169,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1741_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_21",
    cx: 7.11026,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_21",
    cx: 10.1376,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_21",
    cx: 13.1571,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_21",
    cx: 16.1845,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_21",
    cx: 19.2079,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_21",
    cx: 22.2314,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_21",
    cx: 25.2548,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_21",
    cx: 28.2821,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1742_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_22",
    cx: 7.11026,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_22",
    cx: 10.1376,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_22",
    cx: 13.1571,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_22",
    cx: 16.1845,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_22",
    cx: 19.2079,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_22",
    cx: 22.2314,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_22",
    cx: 25.2548,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_22",
    cx: 28.2821,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1743_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_23",
    cx: 7.11026,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_23",
    cx: 10.1376,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_23",
    cx: 13.1571,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_23",
    cx: 16.1845,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_23",
    cx: 19.2079,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_23",
    cx: 22.2314,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_23",
    cx: 25.2548,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_23",
    cx: 28.2821,
    cy: 47.4911,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1744_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_24",
    cx: 7.11026,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_24",
    cx: 10.1376,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_24",
    cx: 13.1571,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_24",
    cx: 16.1845,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_24",
    cx: 19.2079,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_24",
    cx: 22.2314,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_24",
    cx: 25.2548,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_24",
    cx: 28.2821,
    cy: 50.5126,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1745_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_25",
    cx: 7.11026,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_25",
    cx: 10.1376,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_25",
    cx: 13.1571,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_25",
    cx: 16.1845,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_25",
    cx: 19.2079,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_25",
    cx: 22.2314,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_25",
    cx: 25.2548,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_25",
    cx: 28.2821,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1746_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_26",
    cx: 7.11026,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_26",
    cx: 10.1376,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_26",
    cx: 13.1571,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_26",
    cx: 16.1845,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_26",
    cx: 19.2079,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_26",
    cx: 22.2314,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_26",
    cx: 25.2548,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_26",
    cx: 28.2821,
    cy: 56.5634,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1747_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_27",
    cx: 7.11026,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_27",
    cx: 10.1376,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_27",
    cx: 13.1571,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_27",
    cx: 16.1845,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_27",
    cx: 19.2079,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_27",
    cx: 22.2314,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_27",
    cx: 25.2548,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_27",
    cx: 28.2821,
    cy: 59.5878,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1748"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_28",
    cx: 7.11026,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_28",
    cx: 10.1376,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_28",
    cx: 13.1571,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_28",
    cx: 16.1845,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_28",
    cx: 19.2079,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_28",
    cx: 22.2314,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_28",
    cx: 25.2548,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_28",
    cx: 28.2821,
    cy: 62.6112,
    r: 0.403229,
    fill: "#D9D9D9"
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "1_2",
    d: "M27.6497 15.5798H28.2546V14.975H27.6497V15.5798ZM27.6497 63.7354V64.3402H28.2546V63.7354H27.6497ZM16.5039 63.7354H15.899V64.3402H16.5039V63.7354ZM16.5039 28.1479H17.1087V27.341L16.3342 27.5673L16.5039 28.1479ZM5.52333 31.356H4.91849V32.1629L5.69296 31.9366L5.52333 31.356ZM5.52333 22.8891L5.32536 22.3176L4.91849 22.4586V22.8891H5.52333ZM26.6245 15.5798V14.975H26.5227L26.4265 15.0083L26.6245 15.5798ZM27.0449 15.5798V63.7354H28.2546V15.5798H27.0449ZM27.6497 63.1305H16.5039V64.3402H27.6497V63.1305ZM17.1087 63.7354V28.1479H15.899V63.7354H17.1087ZM16.3342 27.5673L5.35371 30.7755L5.69296 31.9366L16.6735 28.7285L16.3342 27.5673ZM6.12818 31.356V22.8891H4.91849V31.356H6.12818ZM5.72131 23.4607L26.8224 16.1513L26.4265 15.0083L5.32536 22.3176L5.72131 23.4607ZM26.6245 16.1847H27.6497V14.975H26.6245V16.1847Z",
    fill: "#202124"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1527_646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 16,
    width: 34,
    height: 50
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M52.955 43.2792L44.0912 41.1956L47.0017 16.5886H75.1476V25.254H56.0971L55.0056 34.8123C55.5348 34.5036 56.4278 34.1398 57.6846 33.7209C58.9635 33.2799 60.3746 33.0594 61.9181 33.0594C64.2994 33.0594 66.4051 33.4232 68.2352 34.1508C70.0873 34.8564 71.6528 35.9037 72.9316 37.2928C74.2105 38.6599 75.1696 40.3467 75.8091 42.3531C76.4706 44.3596 76.8013 46.6527 76.8013 49.2325C76.8013 51.3051 76.4595 53.3116 75.776 55.2519C75.1145 57.1702 74.0892 58.9011 72.7001 60.4445C71.3331 61.9659 69.6022 63.1786 67.5075 64.0827C65.4129 64.9646 62.9323 65.4056 60.0659 65.4056C57.9271 65.4056 55.8435 65.0749 53.815 64.4134C51.7864 63.7519 49.9563 62.8038 48.3247 61.5691C46.7151 60.3122 45.4363 58.8019 44.4881 57.0379C43.5621 55.2519 43.1101 53.2565 43.1321 51.0516H54.3441C54.4103 52.2202 54.6859 53.2344 55.171 54.0944C55.6561 54.9543 56.3065 55.6268 57.1223 56.1119C57.9602 56.5749 58.9194 56.8064 59.9998 56.8064C61.1022 56.8064 62.0173 56.5859 62.7449 56.1449C63.4725 55.704 64.0458 55.0976 64.4647 54.3259C64.8837 53.5542 65.1813 52.6722 65.3577 51.68C65.5341 50.6657 65.6223 49.5963 65.6223 48.4718C65.6223 47.2811 65.49 46.2118 65.2254 45.2636C64.9829 44.3155 64.586 43.5107 64.0348 42.8492C63.4836 42.1657 62.767 41.6476 61.885 41.2948C61.0251 40.942 59.9887 40.7656 58.776 40.7656C57.1664 40.7656 55.8986 41.0412 54.9725 41.5924C54.0465 42.1437 53.374 42.7059 52.955 43.2792Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1527_646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1757_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1661_3",
    x: 16.0234,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1663_3",
    x: 16.0234,
    y: 41.1387,
    width: 43.3471,
    height: 43.3471,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1662_3",
    x: 59.375,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1664_3",
    x: 59.375,
    y: 41.1387,
    width: 43.3471,
    height: 43.3471,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1756_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1733_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_29",
    cx: 44.247,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_29",
    cx: 47.2743,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_29",
    cx: 50.2939,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_29",
    cx: 53.3212,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_29",
    cx: 56.3446,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_29",
    cx: 59.3681,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_29",
    cx: 62.3915,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_29",
    cx: 65.4189,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_13",
    cx: 68.4384,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_13",
    cx: 71.4657,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_13",
    cx: 74.4931,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1734_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_30",
    cx: 44.247,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_30",
    cx: 47.2743,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_30",
    cx: 50.2939,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_30",
    cx: 53.3212,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_30",
    cx: 56.3446,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_30",
    cx: 59.3681,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_30",
    cx: 62.3915,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_30",
    cx: 65.4189,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_14",
    cx: 68.4384,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_14",
    cx: 71.4657,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_14",
    cx: 74.4931,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1735_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_31",
    cx: 44.247,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_31",
    cx: 47.2743,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_31",
    cx: 50.2939,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_31",
    cx: 53.3212,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_31",
    cx: 56.3446,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_31",
    cx: 59.3681,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_31",
    cx: 62.3915,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_31",
    cx: 65.4189,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_15",
    cx: 68.4384,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_15",
    cx: 71.4657,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_15",
    cx: 74.4931,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1736_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_32",
    cx: 44.247,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_32",
    cx: 47.2743,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_32",
    cx: 50.2939,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_32",
    cx: 53.3212,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_32",
    cx: 56.3446,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_32",
    cx: 59.3681,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_32",
    cx: 62.3915,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_32",
    cx: 65.4189,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_16",
    cx: 68.4384,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_16",
    cx: 71.4657,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_16",
    cx: 74.4931,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1737_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_33",
    cx: 44.247,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_33",
    cx: 47.2743,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_33",
    cx: 50.2939,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_33",
    cx: 53.3212,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_33",
    cx: 56.3446,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_33",
    cx: 59.3681,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_33",
    cx: 62.3915,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_33",
    cx: 65.4189,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_17",
    cx: 68.4384,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_17",
    cx: 71.4657,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_17",
    cx: 74.4931,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1738_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_34",
    cx: 44.247,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_34",
    cx: 47.2743,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_34",
    cx: 50.2939,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_34",
    cx: 53.3212,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_34",
    cx: 56.3446,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_34",
    cx: 59.3681,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_34",
    cx: 62.3915,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_34",
    cx: 65.4189,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_18",
    cx: 68.4384,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_18",
    cx: 71.4657,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_18",
    cx: 74.4931,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1739_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_35",
    cx: 44.247,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_35",
    cx: 47.2743,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_35",
    cx: 50.2939,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_35",
    cx: 53.3212,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_35",
    cx: 56.3446,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_35",
    cx: 59.3681,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_35",
    cx: 62.3915,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_35",
    cx: 65.4189,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_19",
    cx: 68.4384,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_19",
    cx: 71.4657,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_19",
    cx: 74.4931,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1740_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_36",
    cx: 44.247,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_36",
    cx: 47.2743,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_36",
    cx: 50.2939,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_36",
    cx: 53.3212,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_36",
    cx: 56.3446,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_36",
    cx: 59.3681,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_36",
    cx: 62.3915,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_36",
    cx: 65.4189,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_20",
    cx: 68.4384,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_20",
    cx: 71.4657,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_20",
    cx: 74.4931,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1741_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_37",
    cx: 44.247,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_37",
    cx: 47.2743,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_37",
    cx: 50.2939,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_37",
    cx: 53.3212,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_37",
    cx: 56.3446,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_37",
    cx: 59.3681,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_37",
    cx: 62.3915,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_37",
    cx: 65.4189,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_21",
    cx: 68.4384,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_21",
    cx: 71.4657,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_21",
    cx: 74.4931,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1742_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_38",
    cx: 44.247,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_38",
    cx: 47.2743,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_38",
    cx: 50.2939,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_38",
    cx: 53.3212,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_38",
    cx: 56.3446,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_38",
    cx: 59.3681,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_38",
    cx: 62.3915,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_38",
    cx: 65.4189,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_22",
    cx: 68.4384,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_22",
    cx: 71.4657,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_22",
    cx: 74.4931,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1743_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_39",
    cx: 44.247,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_39",
    cx: 47.2743,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_39",
    cx: 50.2939,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_39",
    cx: 53.3212,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_39",
    cx: 56.3446,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_39",
    cx: 59.3681,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_39",
    cx: 62.3915,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_39",
    cx: 65.4189,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_23",
    cx: 68.4384,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_23",
    cx: 71.4657,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_23",
    cx: 74.4931,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1744_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_40",
    cx: 44.247,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_40",
    cx: 47.2743,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_40",
    cx: 50.2939,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_40",
    cx: 53.3212,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_40",
    cx: 56.3446,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_40",
    cx: 59.3681,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_40",
    cx: 62.3915,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_40",
    cx: 65.4189,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_24",
    cx: 68.4384,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_24",
    cx: 71.4657,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_24",
    cx: 74.4931,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1745_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_41",
    cx: 44.247,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_41",
    cx: 47.2743,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_41",
    cx: 50.2939,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_41",
    cx: 53.3212,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_41",
    cx: 56.3446,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_41",
    cx: 59.3681,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_41",
    cx: 62.3915,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_41",
    cx: 65.4189,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_25",
    cx: 68.4384,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_25",
    cx: 71.4657,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_25",
    cx: 74.4931,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1746_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_42",
    cx: 44.247,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_42",
    cx: 47.2743,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_42",
    cx: 50.2939,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_42",
    cx: 53.3212,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_42",
    cx: 56.3446,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_42",
    cx: 59.3681,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_42",
    cx: 62.3915,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_42",
    cx: 65.4189,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_26",
    cx: 68.4384,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_26",
    cx: 71.4657,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_26",
    cx: 74.4931,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1747_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_43",
    cx: 44.247,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_43",
    cx: 47.2743,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_43",
    cx: 50.2939,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_43",
    cx: 53.3212,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_43",
    cx: 56.3446,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_43",
    cx: 59.3681,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_43",
    cx: 62.3915,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_43",
    cx: 65.4189,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_27",
    cx: 68.4384,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_27",
    cx: 71.4657,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_27",
    cx: 74.4931,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1748_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_44",
    cx: 44.247,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_44",
    cx: 47.2743,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_44",
    cx: 50.2939,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_44",
    cx: 53.3212,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_44",
    cx: 56.3446,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_44",
    cx: 59.3681,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_44",
    cx: 62.3915,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_44",
    cx: 65.4189,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_28",
    cx: 68.4384,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_28",
    cx: 71.4657,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_28",
    cx: 74.4931,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1749"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_45",
    cx: 44.247,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_45",
    cx: 47.2743,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_45",
    cx: 50.2939,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_45",
    cx: 53.3212,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_45",
    cx: 56.3446,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_45",
    cx: 59.3681,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_45",
    cx: 62.3915,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_45",
    cx: 65.4189,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_29",
    cx: 68.4384,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_29",
    cx: 71.4657,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_29",
    cx: 74.4931,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "5_2",
    d: "M51.8457 42.2704L51.7073 42.8592L52.0975 42.9509L52.334 42.6273L51.8457 42.2704ZM42.9819 40.1868L42.3812 40.1157L42.3178 40.652L42.8435 40.7756L42.9819 40.1868ZM45.8924 15.5798V14.975H45.3549L45.2917 15.5088L45.8924 15.5798ZM74.0382 15.5798H74.6431V14.975H74.0382V15.5798ZM74.0382 24.2452V24.85H74.6431V24.2452H74.0382ZM54.9877 24.2452V23.6403H54.448L54.3867 24.1766L54.9877 24.2452ZM53.8962 33.8035L53.2953 33.7349L53.1584 34.9342L54.201 34.326L53.8962 33.8035ZM56.5752 32.7121L56.7665 33.2859L56.7724 33.2839L56.5752 32.7121ZM67.1258 33.142L66.9023 33.7041L66.9105 33.7073L67.1258 33.142ZM71.8223 36.2841L71.3773 36.6937L71.3806 36.6973L71.8223 36.2841ZM74.6997 41.3444L74.1234 41.528L74.1253 41.5337L74.6997 41.3444ZM74.6666 54.2432L74.0961 54.0422L74.0948 54.046L74.6666 54.2432ZM71.5908 59.4358L71.1412 59.0311L71.1409 59.0315L71.5908 59.4358ZM66.3982 63.0739L66.6329 63.6313L66.6378 63.6292L66.3982 63.0739ZM47.2153 60.5603L46.843 61.037L46.8503 61.0426L47.2153 60.5603ZM43.3788 56.0291L42.8417 56.3076L42.846 56.3155L43.3788 56.0291ZM42.0227 50.0428V49.4379H41.4239L41.4179 50.0367L42.0227 50.0428ZM53.2348 50.0428L53.8386 50.0086L53.8063 49.4379H53.2348V50.0428ZM56.013 55.1031L55.7039 55.623L55.7121 55.6278L55.7204 55.6325L56.013 55.1031ZM61.6355 55.1361L61.322 54.6189L61.6355 55.1361ZM64.2484 50.6712L64.8439 50.777L64.8443 50.7748L64.2484 50.6712ZM64.1161 44.2549L63.53 44.4048L63.5335 44.4174L64.1161 44.2549ZM62.9254 41.8405L62.4545 42.2202L62.4608 42.2277L62.9254 41.8405ZM60.7756 40.286L60.546 40.8456L60.551 40.8476L60.7756 40.286ZM51.9841 41.6816L43.1203 39.598L42.8435 40.7756L51.7073 42.8592L51.9841 41.6816ZM43.5825 40.2578L46.493 15.6509L45.2917 15.5088L42.3812 40.1157L43.5825 40.2578ZM45.8924 16.1847H74.0382V14.975H45.8924V16.1847ZM73.4334 15.5798V24.2452H74.6431V15.5798H73.4334ZM74.0382 23.6403H54.9877V24.85H74.0382V23.6403ZM54.3867 24.1766L53.2953 33.7349L54.4972 33.8721L55.5886 24.3138L54.3867 24.1766ZM54.201 34.326C54.6725 34.0509 55.5146 33.7032 56.7665 33.2859L56.384 32.1383C55.1223 32.5588 54.1784 32.9387 53.5915 33.2811L54.201 34.326ZM56.7724 33.2839C57.9796 32.8676 59.323 32.6554 60.8087 32.6554V31.4458C59.2075 31.4458 57.7286 31.6746 56.3781 32.1403L56.7724 33.2839ZM60.8087 32.6554C63.1291 32.6554 65.1565 33.01 66.9023 33.7041L67.3493 32.58C65.4349 31.8189 63.2509 31.4458 60.8087 31.4458V32.6554ZM66.9105 33.7073C68.6795 34.3812 70.1651 35.377 71.3773 36.6937L72.2673 35.8744C70.9218 34.4129 69.2763 33.314 67.3411 32.5768L66.9105 33.7073ZM71.3806 36.6973C72.5908 37.991 73.5078 39.5963 74.1234 41.528L75.276 41.1607C74.6127 39.0794 73.6114 37.3112 72.264 35.8708L71.3806 36.6973ZM74.1253 41.5337C74.7627 43.4673 75.0871 45.6946 75.0871 48.2237H76.2968C76.2968 45.5933 75.9596 43.2343 75.2741 41.155L74.1253 41.5337ZM75.0871 48.2237C75.0871 50.2284 74.7568 52.1669 74.0961 54.0422L75.2371 54.4441C75.9435 52.4387 76.2968 50.3643 76.2968 48.2237H75.0871ZM74.0948 54.046C73.4604 55.8858 72.4773 57.5465 71.1412 59.0311L72.0403 59.8404C73.4824 58.2381 74.5499 56.4371 75.2384 54.4403L74.0948 54.046ZM71.1409 59.0315C69.8386 60.4808 68.1823 61.6451 66.1585 62.5185L66.6378 63.6292C68.8034 62.6946 70.6088 61.4335 72.0407 59.84L71.1409 59.0315ZM66.1634 62.5164C64.1597 63.3601 61.7626 63.792 58.9565 63.792V65.0017C61.8833 65.0017 64.4472 64.5516 66.6329 63.6313L66.1634 62.5164ZM58.9565 63.792C56.8813 63.792 54.8609 63.4713 52.8931 62.8296L52.5181 63.9797C54.6073 64.6609 56.7542 65.0017 58.9565 65.0017V63.792ZM52.8931 62.8296C50.9257 62.188 49.1561 61.2704 47.5803 60.078L46.8503 61.0426C48.5378 62.3196 50.4284 63.2982 52.5181 63.9797L52.8931 62.8296ZM47.5876 60.0835C46.0428 58.8773 44.8191 57.4313 43.9115 55.7428L42.846 56.3155C43.8346 58.1548 45.1687 59.7296 46.8431 61.037L47.5876 60.0835ZM43.9157 55.7507C43.0395 54.0608 42.6064 52.1645 42.6275 50.0488L41.4179 50.0367C41.395 52.3309 41.8659 54.4255 42.8418 56.3076L43.9157 55.7507ZM42.0227 50.6476H53.2348V49.4379H42.0227V50.6476ZM52.6309 50.077C52.7013 51.321 52.9966 52.4286 53.5348 53.3827L54.5884 52.7884C54.1565 52.0227 53.9005 51.1018 53.8386 50.0086L52.6309 50.077ZM53.5348 53.3827C54.0696 54.3308 54.7935 55.0817 55.7039 55.623L56.3221 54.5832C55.6008 54.1543 55.0238 53.5602 54.5884 52.7884L53.5348 53.3827ZM55.7204 55.6325C56.6589 56.1511 57.721 56.4025 58.8904 56.4025V55.1928C57.8989 55.1928 57.0428 54.9811 56.3055 54.5737L55.7204 55.6325ZM58.8904 56.4025C60.0713 56.4025 61.1028 56.1663 61.949 55.6534L61.322 54.6189C60.713 54.988 59.9144 55.1928 58.8904 55.1928V56.4025ZM61.949 55.6534C62.7713 55.155 63.4186 54.4684 63.8869 53.6057L62.8238 53.0285C62.4543 53.7092 61.955 54.2353 61.322 54.6189L61.949 55.6534ZM63.8869 53.6057C64.341 52.7691 64.6578 51.8239 64.8439 50.777L63.6529 50.5653C63.4862 51.5029 63.2076 52.3216 62.8238 53.0285L63.8869 53.6057ZM64.8443 50.7748C65.0271 49.7234 65.1178 48.6191 65.1178 47.463H63.9081C63.9081 48.5559 63.8224 49.5905 63.6525 50.5675L64.8443 50.7748ZM65.1178 47.463C65.1178 46.2285 64.9807 45.103 64.6986 44.0923L63.5335 44.4174C63.7806 45.3029 63.9081 46.3162 63.9081 47.463H65.1178ZM64.702 44.105C64.4403 43.0816 64.0063 42.1927 63.3901 41.4532L62.4608 42.2277C62.947 42.8112 63.3068 43.5318 63.5301 44.4048L64.702 44.105ZM63.3962 41.4608C62.7746 40.69 61.9704 40.1125 61.0002 39.7244L60.551 40.8476C61.3448 41.1651 61.9737 41.6239 62.4546 42.2202L63.3962 41.4608ZM61.0052 39.7264C60.0539 39.3361 58.9353 39.152 57.6667 39.152V40.3617C58.8235 40.3617 59.7775 40.5303 60.546 40.8456L61.0052 39.7264ZM57.6667 39.152C55.9981 39.152 54.6087 39.436 53.5538 40.0639L54.1725 41.1034C54.9698 40.6288 56.116 40.3617 57.6667 40.3617V39.152ZM53.5538 40.0639C52.5904 40.6373 51.8426 41.2495 51.3573 41.9136L52.334 42.6273C52.6866 42.1448 53.2838 41.6324 54.1725 41.1034L53.5538 40.0639Z",
    fill: "#202124"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1527_646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 15,
    width: 35,
    height: 51
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 0,
    d: "M116.215 36.2676V45.0652C116.215 48.5269 115.807 51.5366 114.991 54.0944C114.198 56.6521 113.051 58.7688 111.552 60.4445C110.074 62.1203 108.31 63.3661 106.26 64.1819C104.209 64.9977 101.949 65.4056 99.4797 65.4056C97.4953 65.4056 95.6432 65.1521 93.9233 64.6449C92.2035 64.1157 90.649 63.322 89.2599 62.2636C87.8929 61.1832 86.7132 59.8382 85.721 58.2286C84.7288 56.619 83.9681 54.7228 83.4389 52.5399C82.9097 50.335 82.6451 47.8434 82.6451 45.0652V36.2676C82.6451 32.7838 83.042 29.7741 83.8358 27.2384C84.6516 24.6807 85.8092 22.564 87.3085 20.8882C88.8079 19.2125 90.5829 17.9667 92.6334 17.1509C94.684 16.335 96.9441 15.9271 99.4136 15.9271C101.398 15.9271 103.239 16.1917 104.937 16.7209C106.657 17.228 108.211 18.0218 109.6 19.1022C110.989 20.1606 112.169 21.4946 113.139 23.1042C114.131 24.7138 114.892 26.621 115.421 28.8259C115.951 31.0088 116.215 33.4893 116.215 36.2676ZM105.069 46.4212V34.8454C105.069 33.3019 104.981 31.9569 104.805 30.8104C104.65 29.6638 104.408 28.6936 104.077 27.8999C103.768 27.1061 103.382 26.4667 102.919 25.9816C102.456 25.4745 101.927 25.1106 101.332 24.8901C100.759 24.6476 100.119 24.5263 99.4136 24.5263C98.5316 24.5263 97.7378 24.7138 97.0323 25.0886C96.3487 25.4414 95.7644 26.0147 95.2793 26.8084C94.7943 27.6022 94.4194 28.6606 94.1548 29.9835C93.9123 31.3065 93.791 32.9271 93.791 34.8454V46.4212C93.791 47.9867 93.8682 49.3538 94.0225 50.5224C94.1989 51.6689 94.4415 52.6501 94.7502 53.466C95.0809 54.2597 95.4778 54.9102 95.9408 55.4173C96.4039 55.9024 96.933 56.2552 97.5284 56.4757C98.1237 56.6962 98.7741 56.8064 99.4797 56.8064C100.34 56.8064 101.111 56.63 101.795 56.2772C102.478 55.9244 103.063 55.3512 103.548 54.5574C104.055 53.7416 104.43 52.6722 104.672 51.3492C104.937 50.0042 105.069 48.3616 105.069 46.4212Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1527_646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1757_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1661_4",
    x: 55.375,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1663_4",
    x: 55.375,
    y: 41.1406,
    width: 43.3471,
    height: 43.3471,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1662_4",
    x: 98.7266,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1664_4",
    x: 98.7266,
    y: 41.1406,
    width: 43.3471,
    height: 43.3471,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1756_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1733_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_46",
    cx: 83.5985,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_46",
    cx: 86.6259,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_46",
    cx: 89.6454,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_46",
    cx: 92.6728,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_46",
    cx: 95.7001,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_46",
    cx: 98.7196,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_46",
    cx: 101.743,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_46",
    cx: 104.77,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_30",
    cx: 107.79,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_30",
    cx: 110.817,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_30",
    cx: 113.845,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1734_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_47",
    cx: 83.5985,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_47",
    cx: 86.6259,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_47",
    cx: 89.6454,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_47",
    cx: 92.6728,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_47",
    cx: 95.7001,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_47",
    cx: 98.7196,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_47",
    cx: 101.743,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_47",
    cx: 104.77,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_31",
    cx: 107.79,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_31",
    cx: 110.817,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_31",
    cx: 113.845,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1735_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_48",
    cx: 83.5985,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_48",
    cx: 86.6259,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_48",
    cx: 89.6454,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_48",
    cx: 92.6728,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_48",
    cx: 95.7001,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_48",
    cx: 98.7196,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_48",
    cx: 101.743,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_48",
    cx: 104.77,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_32",
    cx: 107.79,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_32",
    cx: 110.817,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_32",
    cx: 113.845,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1736_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_49",
    cx: 83.5985,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_49",
    cx: 86.6259,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_49",
    cx: 89.6454,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_49",
    cx: 92.6728,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_49",
    cx: 95.7001,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_49",
    cx: 98.7196,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_49",
    cx: 101.743,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_49",
    cx: 104.77,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_33",
    cx: 107.79,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_33",
    cx: 110.817,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_33",
    cx: 113.845,
    cy: 26.3202,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1737_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_50",
    cx: 83.5985,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_50",
    cx: 86.6259,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_50",
    cx: 89.6454,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_50",
    cx: 92.6728,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_50",
    cx: 95.7001,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_50",
    cx: 98.7196,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_50",
    cx: 101.743,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_50",
    cx: 104.77,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_34",
    cx: 107.79,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_34",
    cx: 110.817,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_34",
    cx: 113.845,
    cy: 29.3456,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1738_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_51",
    cx: 83.5985,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_51",
    cx: 86.6259,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_51",
    cx: 89.6454,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_51",
    cx: 92.6728,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_51",
    cx: 95.7001,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_51",
    cx: 98.7196,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_51",
    cx: 101.743,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_51",
    cx: 104.77,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_35",
    cx: 107.79,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_35",
    cx: 110.817,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_35",
    cx: 113.845,
    cy: 32.369,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1739_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_52",
    cx: 83.5985,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_52",
    cx: 86.6259,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_52",
    cx: 89.6454,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_52",
    cx: 92.6728,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_52",
    cx: 95.7001,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_52",
    cx: 98.7196,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_52",
    cx: 101.743,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_52",
    cx: 104.77,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_36",
    cx: 107.79,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_36",
    cx: 110.817,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_36",
    cx: 113.845,
    cy: 35.3925,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1740_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_53",
    cx: 83.5985,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_53",
    cx: 86.6259,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_53",
    cx: 89.6454,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_53",
    cx: 92.6728,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_53",
    cx: 95.7001,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_53",
    cx: 98.7196,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_53",
    cx: 101.743,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_53",
    cx: 104.77,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_37",
    cx: 107.79,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_37",
    cx: 110.817,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_37",
    cx: 113.845,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1741_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_54",
    cx: 83.5985,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_54",
    cx: 86.6259,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_54",
    cx: 89.6454,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_54",
    cx: 92.6728,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_54",
    cx: 95.7001,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_54",
    cx: 98.7196,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_54",
    cx: 101.743,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_54",
    cx: 104.77,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_38",
    cx: 107.79,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_38",
    cx: 110.817,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_38",
    cx: 113.845,
    cy: 41.4413,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1742_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_55",
    cx: 83.5985,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_55",
    cx: 86.6259,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_55",
    cx: 89.6454,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_55",
    cx: 92.6728,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_55",
    cx: 95.7001,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_55",
    cx: 98.7196,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_55",
    cx: 101.743,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_55",
    cx: 104.77,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_39",
    cx: 107.79,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_39",
    cx: 110.817,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_39",
    cx: 113.845,
    cy: 44.4648,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1743_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_56",
    cx: 83.5985,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_56",
    cx: 86.6259,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_56",
    cx: 89.6454,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_56",
    cx: 92.6728,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_56",
    cx: 95.7001,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_56",
    cx: 98.7196,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_56",
    cx: 101.743,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_56",
    cx: 104.77,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_40",
    cx: 107.79,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_40",
    cx: 110.817,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_40",
    cx: 113.845,
    cy: 47.4901,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1744_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_57",
    cx: 83.5985,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_57",
    cx: 86.6259,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_57",
    cx: 89.6454,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_57",
    cx: 92.6728,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_57",
    cx: 95.7001,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_57",
    cx: 98.7196,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_57",
    cx: 101.743,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_57",
    cx: 104.77,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_41",
    cx: 107.79,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_41",
    cx: 110.817,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_41",
    cx: 113.845,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1745_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_58",
    cx: 83.5985,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_58",
    cx: 86.6259,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_58",
    cx: 89.6454,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_58",
    cx: 92.6728,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_58",
    cx: 95.7001,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_58",
    cx: 98.7196,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_58",
    cx: 101.743,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_58",
    cx: 104.77,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_42",
    cx: 107.79,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_42",
    cx: 110.817,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_42",
    cx: 113.845,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1746_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_59",
    cx: 83.5985,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_59",
    cx: 86.6259,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_59",
    cx: 89.6454,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_59",
    cx: 92.6728,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_59",
    cx: 95.7001,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_59",
    cx: 98.7196,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_59",
    cx: 101.743,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_59",
    cx: 104.77,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_43",
    cx: 107.79,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_43",
    cx: 110.817,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_43",
    cx: 113.845,
    cy: 56.5624,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1747_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_60",
    cx: 83.5985,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_60",
    cx: 86.6259,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_60",
    cx: 89.6454,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_60",
    cx: 92.6728,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_60",
    cx: 95.7001,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_60",
    cx: 98.7196,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_60",
    cx: 101.743,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_60",
    cx: 104.77,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_44",
    cx: 107.79,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_44",
    cx: 110.817,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_44",
    cx: 113.845,
    cy: 59.5868,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1748_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_61",
    cx: 83.5985,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_61",
    cx: 86.6259,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_61",
    cx: 89.6454,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_61",
    cx: 92.6728,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_61",
    cx: 95.7001,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_61",
    cx: 98.7196,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_61",
    cx: 101.743,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_61",
    cx: 104.77,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_45",
    cx: 107.79,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_45",
    cx: 110.817,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_45",
    cx: 113.845,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1749_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_62",
    cx: 83.5985,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_62",
    cx: 86.6259,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_62",
    cx: 89.6454,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_62",
    cx: 92.6728,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_62",
    cx: 95.7001,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_62",
    cx: 98.7196,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_62",
    cx: 101.743,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_62",
    cx: 104.77,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_46",
    cx: 107.79,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_46",
    cx: 110.817,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_46",
    cx: 113.845,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }))))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "0_2",
    d: "M113.882 53.0856L113.306 52.9018L113.304 52.9063L113.882 53.0856ZM110.442 59.4358L109.992 59.0324L109.989 59.0358L110.442 59.4358ZM92.8139 63.6361L92.6361 64.2143L92.6429 64.2163L92.8139 63.6361ZM88.1505 61.2548L87.7754 61.7294L87.784 61.7359L88.1505 61.2548ZM82.3295 51.5311L81.7414 51.6723L81.7417 51.6736L82.3295 51.5311ZM82.7264 26.2296L82.1502 26.0458L82.1492 26.0489L82.7264 26.2296ZM103.828 15.7121L103.648 16.2896L103.656 16.2923L103.828 15.7121ZM108.491 18.0934L108.12 18.5709L108.124 18.5745L108.491 18.0934ZM112.03 22.0954L111.512 22.4076L111.515 22.4128L112.03 22.0954ZM114.312 27.8171L113.724 27.9583L113.724 27.9596L114.312 27.8171ZM103.695 29.8016L103.096 29.8823L103.097 29.8935L103.695 29.8016ZM102.968 26.8911L102.404 27.1103L102.407 27.117L102.409 27.1237L102.968 26.8911ZM101.81 24.9728L101.363 25.3807L101.373 25.3904L101.81 24.9728ZM100.222 23.8814L99.9868 24.4384L99.9995 24.4438L100.012 24.4485L100.222 23.8814ZM95.9229 24.0798L96.2003 24.6173L96.2066 24.6139L95.9229 24.0798ZM93.0455 28.9747L92.4523 28.8561L92.4505 28.8657L93.0455 28.9747ZM92.9132 49.5136L92.3134 49.5928L92.3154 49.6056L92.9132 49.5136ZM93.6408 52.4572L93.0751 52.6712L93.0786 52.6806L93.0825 52.6898L93.6408 52.4572ZM94.8314 54.4085L94.3847 54.8165L94.3939 54.8262L94.8314 54.4085ZM96.419 55.4669L96.2089 56.0341L96.419 55.4669ZM100.686 55.2684L100.963 55.8059L100.686 55.2684ZM102.438 53.5486L101.925 53.2293L101.922 53.2332L102.438 53.5486ZM103.563 50.3404L102.969 50.2237L102.968 50.2314L103.563 50.3404ZM114.501 35.2588V44.0564H115.711V35.2588H114.501ZM114.501 44.0564C114.501 47.4728 114.098 50.4178 113.306 52.9018L114.458 53.2694C115.298 50.6379 115.711 47.5634 115.711 44.0564H114.501ZM113.304 52.9063C112.531 55.3967 111.423 57.4326 109.992 59.0324L110.893 59.8391C112.46 58.0874 113.645 55.8899 114.46 53.2648L113.304 52.9063ZM109.989 59.0358C108.573 60.6411 106.888 61.8309 104.927 62.6111L105.374 63.7351C107.514 62.8837 109.357 61.5819 110.896 59.8357L109.989 59.0358ZM104.927 62.6111C102.955 63.3954 100.772 63.792 98.3703 63.792V65.0017C100.907 65.0017 103.244 64.5824 105.374 63.7351L104.927 62.6111ZM98.3703 63.792C96.4377 63.792 94.6437 63.5451 92.985 63.056L92.6429 64.2163C94.4238 64.7414 96.3341 65.0017 98.3703 65.0017V63.792ZM92.9918 63.058C91.338 62.5492 89.8478 61.7876 88.5171 60.7737L87.784 61.7359C89.2315 62.8388 90.8502 63.6647 92.6361 64.2142L92.9918 63.058ZM88.5256 60.7803C87.2185 59.7473 86.0848 58.457 85.1265 56.9024L84.0967 57.5372C85.1229 59.2018 86.3485 60.6015 87.7755 61.7293L88.5256 60.7803ZM85.1265 56.9024C84.1732 55.356 83.4343 53.521 82.9173 51.3886L81.7417 51.6736C82.2831 53.907 83.0656 55.8644 84.0967 57.5372L85.1265 56.9024ZM82.9177 51.3899C82.4017 49.2402 82.1406 46.7973 82.1406 44.0564H80.9309C80.9309 46.8719 81.199 49.4121 81.7414 51.6723L82.9177 51.3899ZM82.1406 44.0564V35.2588H80.9309V44.0564H82.1406ZM82.1406 35.2588C82.1406 31.8184 82.5329 28.8725 83.3036 26.4103L82.1492 26.0489C81.3324 28.658 80.9309 31.7316 80.9309 35.2588H82.1406ZM83.3027 26.4134C84.0975 23.9214 85.2173 21.8839 86.6499 20.2827L85.7484 19.4761C84.1823 21.2265 82.987 23.4224 82.1502 26.0458L83.3027 26.4134ZM86.6499 20.2827C88.0881 18.6754 89.7857 17.4846 91.7477 16.7041L91.3005 15.5801C89.1612 16.4312 87.309 17.732 85.7484 19.4761L86.6499 20.2827ZM91.7477 16.7041C93.7191 15.9197 95.9022 15.5232 98.3042 15.5232V14.3135C95.7672 14.3135 93.4302 14.7328 91.3005 15.5801L91.7477 16.7041ZM98.3042 15.5232C100.235 15.5232 102.014 15.7805 103.648 16.2896L104.008 15.1347C102.245 14.5854 100.343 14.3135 98.3042 14.3135V15.5232ZM103.656 16.2923C105.305 16.7784 106.791 17.5378 108.12 18.5709L108.862 17.616C107.412 16.4882 105.79 15.6601 103.999 15.132L103.656 16.2923ZM108.124 18.5745C109.448 19.5833 110.578 20.8583 111.512 22.4076L112.548 21.7831C111.541 20.1132 110.312 18.7203 108.858 17.6123L108.124 18.5745ZM111.515 22.4128C112.468 23.9583 113.207 25.8036 113.724 27.9583L114.9 27.676C114.359 25.4208 113.576 23.4517 112.545 21.778L111.515 22.4128ZM113.724 27.9596C114.24 30.0864 114.501 32.5177 114.501 35.2588H115.711C115.711 32.4434 115.443 29.9136 114.9 27.6746L113.724 27.9596ZM104.565 45.4124V33.8366H103.355V45.4124H104.565ZM104.565 33.8366C104.565 32.2717 104.475 30.8947 104.293 29.7096L103.097 29.8935C103.268 31.0016 103.355 32.3145 103.355 33.8366H104.565ZM104.295 29.7209C104.136 28.5388 103.883 27.5143 103.526 26.6584L102.409 27.1237C102.714 27.8554 102.946 28.7712 103.096 29.8823L104.295 29.7209ZM103.531 26.6719C103.201 25.8235 102.778 25.1107 102.248 24.5552L101.373 25.3904C101.768 25.8051 102.116 26.3712 102.404 27.1103L103.531 26.6719ZM102.257 24.565C101.734 23.9926 101.126 23.5708 100.433 23.3142L100.012 24.4485C100.51 24.6329 100.96 24.9388 101.363 25.3806L102.257 24.565ZM100.458 23.3243C99.801 23.0463 99.08 22.9127 98.3042 22.9127V24.1224C98.9396 24.1224 99.4974 24.2313 99.9868 24.4384L100.458 23.3243ZM98.3042 22.9127C97.3338 22.9127 96.4409 23.1197 95.6391 23.5457L96.2066 24.6139C96.816 24.2902 97.5107 24.1224 98.3042 24.1224V22.9127ZM95.6455 23.5423C94.8448 23.9556 94.1846 24.6158 93.6539 25.4842L94.6861 26.115C95.1255 25.3959 95.634 24.9096 96.2003 24.6173L95.6455 23.5423ZM93.6539 25.4842C93.1191 26.3593 92.7252 27.4921 92.4524 28.8561L93.6386 29.0934C93.8949 27.8114 94.2506 26.8276 94.6861 26.115L93.6539 25.4842ZM92.4505 28.8657C92.1993 30.2362 92.0768 31.8958 92.0768 33.8366H93.2865C93.2865 31.9408 93.4066 30.3592 93.6404 29.0838L92.4505 28.8657ZM92.0768 33.8366V45.4124H93.2865V33.8366H92.0768ZM92.0768 45.4124C92.0768 46.9964 92.1548 48.391 92.3135 49.5928L93.5128 49.4344C93.3628 48.2989 93.2865 46.9595 93.2865 45.4124H92.0768ZM92.3154 49.6056C92.4962 50.7811 92.7475 51.8055 93.0751 52.6712L94.2065 52.2431C93.9167 51.4772 93.6829 50.5392 93.511 49.4216L92.3154 49.6056ZM93.0825 52.6898C93.4336 53.5324 93.8645 54.2466 94.3848 54.8164L95.2781 54.0007C94.8723 53.5562 94.5095 52.9695 94.1991 52.2245L93.0825 52.6898ZM94.3939 54.8262C94.9168 55.3739 95.5226 55.7799 96.2089 56.0341L96.6291 54.8997C96.1248 54.7129 95.6722 54.4133 95.269 53.9909L94.3939 54.8262ZM96.2089 56.0341C96.8786 56.2821 97.601 56.4025 98.3703 56.4025V55.1928C97.7285 55.1928 97.1501 55.0927 96.6291 54.8997L96.2089 56.0341ZM98.3703 56.4025C99.3153 56.4025 100.184 56.208 100.963 55.8059L100.408 54.731C99.82 55.0345 99.1453 55.1928 98.3703 55.1928V56.4025ZM100.963 55.8059C101.764 55.3926 102.424 54.7324 102.955 53.864L101.922 53.2332C101.483 53.9523 100.974 54.4387 100.408 54.731L100.963 55.8059ZM102.952 53.8679C103.512 52.9675 103.907 51.8194 104.158 50.4495L102.968 50.2314C102.734 51.5074 102.379 52.498 101.925 53.2293L102.952 53.8679ZM104.156 50.4572C104.431 49.0616 104.565 47.3772 104.565 45.4124H103.355C103.355 47.3283 103.224 48.9293 102.969 50.2237L104.156 50.4572Z",
    fill: "#202124"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1527_646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 15,
    width: 35,
    height: 51
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "0_3",
    d: "M155.563 36.2676V45.0652C155.563 48.5269 155.155 51.5366 154.339 54.0944C153.545 56.6521 152.399 58.7688 150.899 60.4445C149.422 62.1203 147.658 63.3661 145.608 64.1819C143.557 64.9977 141.297 65.4056 138.827 65.4056C136.843 65.4056 134.991 65.1521 133.271 64.6449C131.551 64.1157 129.997 63.322 128.608 62.2636C127.241 61.1832 126.061 59.8382 125.069 58.2286C124.076 56.619 123.316 54.7228 122.787 52.5399C122.257 50.335 121.993 47.8434 121.993 45.0652V36.2676C121.993 32.7838 122.39 29.7741 123.183 27.2384C123.999 24.6807 125.157 22.564 126.656 20.8882C128.156 19.2125 129.931 17.9667 131.981 17.1509C134.032 16.335 136.292 15.9271 138.761 15.9271C140.746 15.9271 142.587 16.1917 144.285 16.7209C146.004 17.228 147.559 18.0218 148.948 19.1022C150.337 20.1606 151.517 21.4946 152.487 23.1042C153.479 24.7138 154.24 26.621 154.769 28.8259C155.298 31.0088 155.563 33.4893 155.563 36.2676ZM144.417 46.4212V34.8454C144.417 33.3019 144.329 31.9569 144.152 30.8104C143.998 29.6638 143.755 28.6936 143.425 27.8999C143.116 27.1061 142.73 26.4667 142.267 25.9816C141.804 25.4745 141.275 25.1106 140.68 24.8901C140.106 24.6476 139.467 24.5263 138.761 24.5263C137.879 24.5263 137.085 24.7138 136.38 25.0886C135.696 25.4414 135.112 26.0147 134.627 26.8084C134.142 27.6022 133.767 28.6606 133.502 29.9835C133.26 31.3065 133.139 32.9271 133.139 34.8454V46.4212C133.139 47.9867 133.216 49.3538 133.37 50.5224C133.547 51.6689 133.789 52.6501 134.098 53.466C134.429 54.2597 134.825 54.9102 135.288 55.4173C135.752 55.9024 136.281 56.2552 136.876 56.4757C137.471 56.6962 138.122 56.8064 138.827 56.8064C139.687 56.8064 140.459 56.63 141.143 56.2772C141.826 55.9244 142.41 55.3512 142.895 54.5574C143.403 53.7416 143.777 52.6722 144.02 51.3492C144.285 50.0042 144.417 48.3616 144.417 46.4212Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1527_646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1757_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1661_5",
    x: 94.7188,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1663_5",
    x: 94.7188,
    y: 41.1387,
    width: 43.3471,
    height: 43.3471,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1662_5",
    x: 138.07,
    y: -2.20703,
    width: 43.3471,
    height: 43.3471,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1664_5",
    x: 138.07,
    y: 41.1387,
    width: 43.3471,
    height: 43.3471,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1756_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1733_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_63",
    cx: 122.938,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_63",
    cx: 125.966,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_63",
    cx: 128.985,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_63",
    cx: 132.013,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_63",
    cx: 135.036,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_63",
    cx: 138.059,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_63",
    cx: 141.083,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_63",
    cx: 144.11,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_47",
    cx: 147.13,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_47",
    cx: 150.157,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_47",
    cx: 153.184,
    cy: 17.2489,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1734_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_64",
    cx: 122.938,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_64",
    cx: 125.966,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_64",
    cx: 128.985,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_64",
    cx: 132.013,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_64",
    cx: 135.036,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_64",
    cx: 138.059,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_64",
    cx: 141.083,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_64",
    cx: 144.11,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_48",
    cx: 147.13,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_48",
    cx: 150.157,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_48",
    cx: 153.184,
    cy: 20.2724,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1735_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_65",
    cx: 122.938,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_65",
    cx: 125.966,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_65",
    cx: 128.985,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_65",
    cx: 132.013,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_65",
    cx: 135.036,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_65",
    cx: 138.059,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_65",
    cx: 141.083,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_65",
    cx: 144.11,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_49",
    cx: 147.13,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_49",
    cx: 150.157,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_49",
    cx: 153.184,
    cy: 23.2968,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1736_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_66",
    cx: 122.938,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_66",
    cx: 125.966,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_66",
    cx: 128.985,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_66",
    cx: 132.013,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_66",
    cx: 135.036,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_66",
    cx: 138.059,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_66",
    cx: 141.083,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_66",
    cx: 144.11,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_50",
    cx: 147.13,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_50",
    cx: 150.157,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_50",
    cx: 153.184,
    cy: 26.3212,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1737_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_67",
    cx: 122.938,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_67",
    cx: 125.966,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_67",
    cx: 128.985,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_67",
    cx: 132.013,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_67",
    cx: 135.036,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_67",
    cx: 138.059,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_67",
    cx: 141.083,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_67",
    cx: 144.11,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_51",
    cx: 147.13,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_51",
    cx: 150.157,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_51",
    cx: 153.184,
    cy: 29.3476,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1738_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_68",
    cx: 122.938,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_68",
    cx: 125.966,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_68",
    cx: 128.985,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_68",
    cx: 132.013,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_68",
    cx: 135.036,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_68",
    cx: 138.059,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_68",
    cx: 141.083,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_68",
    cx: 144.11,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_52",
    cx: 147.13,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_52",
    cx: 150.157,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_52",
    cx: 153.184,
    cy: 32.37,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1739_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_69",
    cx: 122.938,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_69",
    cx: 125.966,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_69",
    cx: 128.985,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_69",
    cx: 132.013,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_69",
    cx: 135.036,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_69",
    cx: 138.059,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_69",
    cx: 141.083,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_69",
    cx: 144.11,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_53",
    cx: 147.13,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_53",
    cx: 150.157,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_53",
    cx: 153.184,
    cy: 35.3935,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1740_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_70",
    cx: 122.938,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_70",
    cx: 125.966,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_70",
    cx: 128.985,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_70",
    cx: 132.013,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_70",
    cx: 135.036,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_70",
    cx: 138.059,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_70",
    cx: 141.083,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_70",
    cx: 144.11,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_54",
    cx: 147.13,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_54",
    cx: 150.157,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_54",
    cx: 153.184,
    cy: 38.4179,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1741_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_71",
    cx: 122.938,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_71",
    cx: 125.966,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_71",
    cx: 128.985,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_71",
    cx: 132.013,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_71",
    cx: 135.036,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_71",
    cx: 138.059,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_71",
    cx: 141.083,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_71",
    cx: 144.11,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_55",
    cx: 147.13,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_55",
    cx: 150.157,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_55",
    cx: 153.184,
    cy: 41.4423,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1742_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_72",
    cx: 122.938,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_72",
    cx: 125.966,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_72",
    cx: 128.985,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_72",
    cx: 132.013,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_72",
    cx: 135.036,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_72",
    cx: 138.059,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_72",
    cx: 141.083,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_72",
    cx: 144.11,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_56",
    cx: 147.13,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_56",
    cx: 150.157,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_56",
    cx: 153.184,
    cy: 44.4657,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1743_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_73",
    cx: 122.938,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_73",
    cx: 125.966,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_73",
    cx: 128.985,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_73",
    cx: 132.013,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_73",
    cx: 135.036,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_73",
    cx: 138.059,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_73",
    cx: 141.083,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_73",
    cx: 144.11,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_57",
    cx: 147.13,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_57",
    cx: 150.157,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_57",
    cx: 153.184,
    cy: 47.4921,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1744_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_74",
    cx: 122.938,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_74",
    cx: 125.966,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_74",
    cx: 128.985,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_74",
    cx: 132.013,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_74",
    cx: 135.036,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_74",
    cx: 138.059,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_74",
    cx: 141.083,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_74",
    cx: 144.11,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_58",
    cx: 147.13,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_58",
    cx: 150.157,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_58",
    cx: 153.184,
    cy: 50.5136,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1745_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_75",
    cx: 122.938,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_75",
    cx: 125.966,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_75",
    cx: 128.985,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_75",
    cx: 132.013,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_75",
    cx: 135.036,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_75",
    cx: 138.059,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_75",
    cx: 141.083,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_75",
    cx: 144.11,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_59",
    cx: 147.13,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_59",
    cx: 150.157,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_59",
    cx: 153.184,
    cy: 53.5399,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1746_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_76",
    cx: 122.938,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_76",
    cx: 125.966,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_76",
    cx: 128.985,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_76",
    cx: 132.013,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_76",
    cx: 135.036,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_76",
    cx: 138.059,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_76",
    cx: 141.083,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_76",
    cx: 144.11,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_60",
    cx: 147.13,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_60",
    cx: 150.157,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_60",
    cx: 153.184,
    cy: 56.5644,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1747_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_77",
    cx: 122.938,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_77",
    cx: 125.966,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_77",
    cx: 128.985,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_77",
    cx: 132.013,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_77",
    cx: 135.036,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_77",
    cx: 138.059,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_77",
    cx: 141.083,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_77",
    cx: 144.11,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_61",
    cx: 147.13,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_61",
    cx: 150.157,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_61",
    cx: 153.184,
    cy: 59.5888,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1748_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_78",
    cx: 122.938,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_78",
    cx: 125.966,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_78",
    cx: 128.985,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_78",
    cx: 132.013,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_78",
    cx: 135.036,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_78",
    cx: 138.059,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_78",
    cx: 141.083,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_78",
    cx: 144.11,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_62",
    cx: 147.13,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_62",
    cx: 150.157,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_62",
    cx: 153.184,
    cy: 62.6122,
    r: 0.403229,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1749_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48_79",
    cx: 122.938,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49_79",
    cx: 125.966,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50_79",
    cx: 128.985,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51_79",
    cx: 132.013,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_79",
    cx: 135.036,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_79",
    cx: 138.059,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_79",
    cx: 141.083,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55_79",
    cx: 144.11,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56_63",
    cx: 147.13,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57_63",
    cx: 150.157,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58_63",
    cx: 153.184,
    cy: 65.6366,
    r: 0.403229,
    fill: "#D9D9D9"
  }))))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "0_4",
    d: "M153.23 53.0856L152.653 52.9018L152.652 52.9063L153.23 53.0856ZM149.79 59.4358L149.339 59.0324L149.336 59.0358L149.79 59.4358ZM132.162 63.6361L131.984 64.2143L131.991 64.2163L132.162 63.6361ZM127.498 61.2548L127.123 61.7294L127.132 61.7359L127.498 61.2548ZM121.677 51.5311L121.089 51.6723L121.089 51.6736L121.677 51.5311ZM122.074 26.2296L121.498 26.0458L121.497 26.0489L122.074 26.2296ZM143.175 15.7121L142.995 16.2896L143.004 16.2923L143.175 15.7121ZM147.839 18.0934L147.467 18.5709L147.472 18.5745L147.839 18.0934ZM151.378 22.0954L150.859 22.4076L150.863 22.4128L151.378 22.0954ZM153.66 27.8171L153.071 27.9583L153.072 27.9596L153.66 27.8171ZM143.043 29.8016L142.443 29.8823L142.445 29.8935L143.043 29.8016ZM142.315 26.8911L141.752 27.1103L141.754 27.117L141.757 27.1237L142.315 26.8911ZM141.158 24.9728L140.711 25.3807L140.72 25.3904L141.158 24.9728ZM139.57 23.8814L139.334 24.4384L139.347 24.4438L139.36 24.4485L139.57 23.8814ZM135.271 24.0798L135.548 24.6173L135.554 24.6139L135.271 24.0798ZM132.393 28.9747L131.8 28.8561L131.798 28.8657L132.393 28.9747ZM132.261 49.5136L131.661 49.5928L131.663 49.6056L132.261 49.5136ZM132.988 52.4572L132.423 52.6712L132.426 52.6806L132.43 52.6898L132.988 52.4572ZM134.179 54.4085L133.732 54.8165L133.742 54.8262L134.179 54.4085ZM135.767 55.4669L135.557 56.0341L135.767 55.4669ZM140.033 55.2684L140.311 55.8059L140.033 55.2684ZM141.786 53.5486L141.272 53.2293L141.27 53.2332L141.786 53.5486ZM142.911 50.3404L142.317 50.2237L142.316 50.2314L142.911 50.3404ZM153.849 35.2588V44.0564H155.058V35.2588H153.849ZM153.849 44.0564C153.849 47.4728 153.446 50.4178 152.653 52.9018L153.806 53.2694C154.645 50.6379 155.058 47.5634 155.058 44.0564H153.849ZM152.652 52.9063C151.879 55.3967 150.771 57.4326 149.339 59.0324L150.241 59.8391C151.808 58.0874 152.993 55.8899 153.807 53.2648L152.652 52.9063ZM149.336 59.0358C147.921 60.6411 146.236 61.8309 144.275 62.6111L144.722 63.7351C146.862 62.8837 148.704 61.5819 150.244 59.8357L149.336 59.0358ZM144.275 62.6111C142.303 63.3954 140.12 63.792 137.718 63.792V65.0017C140.255 65.0017 142.592 64.5824 144.722 63.7351L144.275 62.6111ZM137.718 63.792C135.785 63.792 133.991 63.5451 132.333 63.056L131.991 64.2163C133.771 64.7414 135.682 65.0017 137.718 65.0017V63.792ZM132.339 63.058C130.686 62.5492 129.195 61.7876 127.865 60.7737L127.132 61.7359C128.579 62.8388 130.198 63.6647 131.984 64.2142L132.339 63.058ZM127.873 60.7803C126.566 59.7473 125.432 58.457 124.474 56.9024L123.444 57.5372C124.471 59.2018 125.696 60.6015 127.123 61.7293L127.873 60.7803ZM124.474 56.9024C123.521 55.356 122.782 53.521 122.265 51.3886L121.089 51.6736C121.631 53.907 122.413 55.8644 123.444 57.5372L124.474 56.9024ZM122.265 51.3899C121.749 49.2402 121.488 46.7973 121.488 44.0564H120.279C120.279 46.8719 120.547 49.4121 121.089 51.6723L122.265 51.3899ZM121.488 44.0564V35.2588H120.279V44.0564H121.488ZM121.488 35.2588C121.488 31.8184 121.881 28.8725 122.651 26.4103L121.497 26.0489C120.68 28.658 120.279 31.7316 120.279 35.2588H121.488ZM122.65 26.4134C123.445 23.9214 124.565 21.8839 125.998 20.2827L125.096 19.4761C123.53 21.2265 122.335 23.4224 121.498 26.0458L122.65 26.4134ZM125.998 20.2827C127.436 18.6754 129.133 17.4846 131.095 16.7041L130.648 15.5801C128.509 16.4312 126.657 17.732 125.096 19.4761L125.998 20.2827ZM131.095 16.7041C133.067 15.9197 135.25 15.5232 137.652 15.5232V14.3135C135.115 14.3135 132.778 14.7328 130.648 15.5801L131.095 16.7041ZM137.652 15.5232C139.582 15.5232 141.362 15.7805 142.995 16.2896L143.355 15.1347C141.593 14.5854 139.69 14.3135 137.652 14.3135V15.5232ZM143.004 16.2923C144.653 16.7784 146.139 17.5378 147.467 18.5709L148.21 17.616C146.76 16.4882 145.137 15.6601 143.346 15.132L143.004 16.2923ZM147.472 18.5745C148.796 19.5833 149.926 20.8583 150.859 22.4076L151.896 21.7831C150.889 20.1132 149.659 18.7203 148.205 17.6123L147.472 18.5745ZM150.863 22.4128C151.815 23.9583 152.554 25.8036 153.071 27.9583L154.248 27.676C153.707 25.4208 152.924 23.4517 151.892 21.778L150.863 22.4128ZM153.072 27.9596C153.587 30.0864 153.849 32.5177 153.849 35.2588H155.058C155.058 32.4434 154.79 29.9136 154.247 27.6746L153.072 27.9596ZM143.912 45.4124V33.8366H142.703V45.4124H143.912ZM143.912 33.8366C143.912 32.2717 143.823 30.8947 143.641 29.7096L142.445 29.8935C142.616 31.0016 142.703 32.3145 142.703 33.8366H143.912ZM143.642 29.7209C143.483 28.5388 143.23 27.5143 142.874 26.6584L141.757 27.1237C142.062 27.8554 142.294 28.7712 142.443 29.8823L143.642 29.7209ZM142.879 26.6719C142.549 25.8235 142.125 25.1107 141.595 24.5552L140.72 25.3904C141.116 25.8051 141.464 26.3712 141.752 27.1103L142.879 26.6719ZM141.604 24.565C141.082 23.9926 140.473 23.5708 139.78 23.3142L139.36 24.4485C139.858 24.6329 140.308 24.9388 140.711 25.3806L141.604 24.565ZM139.806 23.3243C139.149 23.0463 138.428 22.9127 137.652 22.9127V24.1224C138.287 24.1224 138.845 24.2313 139.334 24.4384L139.806 23.3243ZM137.652 22.9127C136.681 22.9127 135.789 23.1197 134.987 23.5457L135.554 24.6139C136.164 24.2902 136.858 24.1224 137.652 24.1224V22.9127ZM134.993 23.5423C134.192 23.9556 133.532 24.6158 133.002 25.4842L134.034 26.115C134.473 25.3959 134.982 24.9096 135.548 24.6173L134.993 23.5423ZM133.002 25.4842C132.467 26.3593 132.073 27.4921 131.8 28.8561L132.986 29.0934C133.243 27.8114 133.598 26.8276 134.034 26.115L133.002 25.4842ZM131.798 28.8657C131.547 30.2362 131.424 31.8958 131.424 33.8366H132.634C132.634 31.9408 132.754 30.3592 132.988 29.0838L131.798 28.8657ZM131.424 33.8366V45.4124H132.634V33.8366H131.424ZM131.424 45.4124C131.424 46.9964 131.502 48.391 131.661 49.5928L132.86 49.4344C132.71 48.2989 132.634 46.9595 132.634 45.4124H131.424ZM131.663 49.6056C131.844 50.7811 132.095 51.8055 132.423 52.6712L133.554 52.2431C133.264 51.4772 133.031 50.5392 132.859 49.4216L131.663 49.6056ZM132.43 52.6898C132.781 53.5324 133.212 54.2466 133.732 54.8164L134.626 54.0007C134.22 53.5562 133.857 52.9695 133.547 52.2245L132.43 52.6898ZM133.742 54.8262C134.264 55.3739 134.87 55.7799 135.557 56.0341L135.977 54.8997C135.472 54.7129 135.02 54.4133 134.617 53.9909L133.742 54.8262ZM135.557 56.0341C136.226 56.2821 136.949 56.4025 137.718 56.4025V55.1928C137.076 55.1928 136.498 55.0927 135.977 54.8997L135.557 56.0341ZM137.718 56.4025C138.663 56.4025 139.532 56.208 140.311 55.8059L139.756 54.731C139.168 55.0345 138.493 55.1928 137.718 55.1928V56.4025ZM140.311 55.8059C141.111 55.3926 141.771 54.7324 142.302 53.864L141.27 53.2332C140.831 53.9523 140.322 54.4387 139.756 54.731L140.311 55.8059ZM142.3 53.8679C142.859 52.9675 143.254 51.8194 143.506 50.4495L142.316 50.2314C142.082 51.5074 141.727 52.498 141.272 53.2293L142.3 53.8679ZM143.504 50.4572C143.779 49.0616 143.912 47.3772 143.912 45.4124H142.703C142.703 47.3283 142.572 48.9293 142.317 50.2237L143.504 50.4572Z",
    fill: "#202124"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1500);
export default __webpack_public_path__ + "static/media/1500+.88b3f4f03ae0a0193798ddc7fab6a1a9.svg";
export { ForwardRef as ReactComponent };